import React, { Component } from 'react';
import { connect } from 'react-redux';
import Datepicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styled, { css } from 'styled-components';
import { onSetSearchFinish, onSetSearchStart } from '../../../actions/search';
import dayjs from '../../../../dayjs/dayjs_timezone';

const DatePickerWrapper = styled.div`${
  ({ style }) => {
    const bbc = style && style.body ? style.body.background : 'inherit';
    const bc = style && style.body ? style.body.color : 'inherit';
    const dpStyle = style && style.datepicker;

    return css`
      margin-top: 15px;
      width: 50%;
      
      .custom-button {
        width: 98%;
        align-items: center;
        background-color: ${bbc};
        border-radius: 10px;
        border-width: 1px;
        color: ${bc};
        display: flex;
        justify-content: center;
        margin: 0 2px;
        min-width: 120px;
        min-height: 45px;
      }
      .custom-button-icon {
        margin: 10px 10px 10px 5px;
      }
      .custom-button-date {
        margin-right: 5px;
      }
      .custom-button-label .label {
        font-size: smaller;
        text-align: left;
      }
      .custom-button-label .date {
        text-align: left;
      }
      .react-datepicker,
      .react-datepicker .react-datepicker__triangle,
      .react-datepicker .react-datepicker__header,
      .react-datepicker .react-datepicker__header .react-datepicker__current-month,
      .react-datepicker .react-datepicker__header .react-datepicker__header__dropdown,
      .react-datepicker .react-datepicker__day {
        background: ${dpStyle.backgroundColor};
        color: ${dpStyle.color};
      }
      .react-datepicker .react-datepicker__triangle:after {
        border-bottom-color: ${dpStyle.backgroundColor};
      }
      .react-datepicker .react-datepicker__navigation-icon:before {
        border-color: ${dpStyle.color};
      }
      .react-datepicker .react-datepicker__day.react-datepicker__day--disabled {
        color: ${dpStyle.selector.inactive.color};
      }
      .react-datepicker .react-datepicker__day:hover {
        background: ${dpStyle.selector.hover.backgroundColor};
        color: ${dpStyle.selector.hover.color};
      }
      .react-datepicker .react-datepicker__day.react-datepicker__day--selected {
        background: ${dpStyle.selector.active.backgroundColor};
        color: ${dpStyle.selector.active.color};
      }
      .react-datepicker .react-datepicker__header .react-datepicker__day-names,
      .react-datepicker .react-datepicker__header .react-datepicker__day-name {
        background-color: ${dpStyle.table_head?.backgroundColor || bbc};
        color: ${dpStyle.table_head?.color || bc};
      }
      .react-datepicker .react-datepicker__header .react-datepicker__day-names {
        margin-top: 4px;  
      }
      .react-datepicker .react-datepicker__header {
          border-bottom: 0 !important;
      }
    }`;
  }
}`;

class Index extends Component {
  onSelect(value) {
    const { finish, type, onSetSearchFinish, onSetSearchStart, start } = this.props;
    const date = dayjs(value);

    if (type === 'start') {
      onSetSearchStart(date);
      if (finish.isBefore(date)) onSetSearchFinish(date);
    } else {
      onSetSearchFinish(date);
    }
  }

  render() {
    const { finish, start, style, translation, type } = this.props;
    const isStart = type === 'start';
    const date = isStart ? start : finish;
    const key = isStart ? 'from' : 'to';
    const minDate = isStart ? dayjs() : start;

    return (
      <DatePickerWrapper style={style}>
        <Datepicker
          selected={(date || dayjs()).toDate()}
          onSelect={(date) => this.onSelect(date)}
          locale={this.props.locale}
          minDate={minDate.toDate()}
          onCalendarOpen={() => { this.props.onOpen() }}
          onCalendarClose={() => { this.props.onClose() }}
          customInput={
            <button className='custom-button'>
              <div className='custom-button-icon'>
                <i className='fa fa-calendar' aria-hidden="true"/>
              </div>
              <div className='custom-button-label'>
                <div className='label'>{translation.key(key)}</div>
                <div className='date'>{date.locale(this.props.region).format("MMM DD")}</div>
              </div>
            </button>
          }
        />
      </DatePickerWrapper>
    );
  }
}

export default connect(
  ({ search, settings }) => ({
    style: settings.style,
    start: search.start,
    finish: search.finish,
  }),
  dispatch => ({
    onSetSearchStart: (e) => dispatch(onSetSearchStart(e)),
    onSetSearchFinish: (a) => dispatch(onSetSearchFinish(a)),
  }),
)(Index);
